import { createElement, useEffect, useRef, type HTMLAttributes } from 'react';
import { observeVisible, radarAnalytics, type RadarProperties } from './radarAnalytics';

/** Keep the existing DOM element; count only its first visible appearance in a session. */
export function RadarItemView({ as = 'section', event = 'radar_item_viewed', properties, active = true, ...attributes }:
  HTMLAttributes<HTMLElement> & { as?: 'section' | 'article' | 'div';
    event?: 'radar_item_viewed' | 'radar_item_opened'; properties: RadarProperties; active?: boolean }) {
  const element = useRef<HTMLElement>(null);
  const snapshot = JSON.stringify(properties);
  useEffect(() => {
    if (!active || !element.current || !properties.workspace_id) return;
    const captured: RadarProperties = JSON.parse(snapshot);
    const key = [captured.workspace_id, captured.screen, captured.watch_id, captured.plan_id,
      captured.item_type, captured.item_id, captured.has_linkedin, captured.has_email, captured.feed_group].join(':');
    return observeVisible(element.current, () => radarAnalytics.once(event, key, captured));
  }, [active, event, snapshot]);
  return createElement(as, { ...attributes, ref: element });
}
